<template>
  <div class="express-vue-temp">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "tf-vue-search"
};
</script>

<style lang="scss">
  @import "assets/scss/index";
  @import "assets/css/TF-Vue-Search.css";
</style>
